import { useRef, useState } from "react";
import { prepareReceiptImages } from "../lib/image.js";

// Shared OCR-fields → contact-form mapping, used by every card-scan entry
// point (Dashboard tile, Add menu, New-contact form) so they can't drift.
export function cardFieldsToPrefill(fields) {
  const full = (fields.name || "").trim();
  const cut = full.lastIndexOf(" ");
  return {
    first_name: cut > 0 ? full.slice(0, cut) : full,
    last_name: cut > 0 ? full.slice(cut + 1) : "",
    title: fields.title || "",
    company: fields.company || "",
    email: fields.email || "",
    phone: fields.phone || "",
    address: fields.address || "",
    website: fields.website || "",
    source: "Business card",
    notes: fields.notes || "",
  };
}

export const isLowConfidence = (fields) => (fields.confidence ?? 0) < 0.7;

// One-tap business-card capture: camera (from a direct tap — iOS requirement),
// downscale, extract via AI, hand fields to the caller. Image isn't stored.
export default function CardScanButton({ label = "📇 Scan business card", className = "", onExtracted }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function onPick(e) {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    setError("");
    try {
      const { original } = await prepareReceiptImages(file);
      const form = new FormData();
      form.append("image", original, "card.jpg");
      const res = await fetch("/api/crm/scan-card", { method: "POST", body: form, credentials: "include" });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Scan failed");
      onExtracted?.(data.fields);
    } catch (err) {
      setError(err.message === "Failed to fetch" ? "No connection — card scanning needs signal." : err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <input ref={fileRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={onPick} />
      <button type="button" onClick={() => fileRef.current?.click()} disabled={busy} className={className}>
        {busy ? "Reading card…" : label}
      </button>
      {error && <p className="mt-1 text-center text-xs text-red-600">{error}</p>}
    </>
  );
}
